import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin-top: 2.6rem;
`;

export const Titulo = styled.h2`
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.5rem;
  letter-spacing: 0em;
  text-align: left;
  color: ${({ theme }) => theme.colors.IMPORTANT};

  @media only screen and (min-width: 768px) {
    font-size: 1.6rem;
    line-height: 2rem;
  }
`;

export const Box = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin-top: 0.6rem;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.colors.IMPORTANT};
  padding: 2rem 3rem;

  cursor: default;
`;

export const Mensagem = styled.span`
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: center;
  color: ${({ theme }) => theme.colors.WHITE};

  @media only screen and (min-width: 768px) {
    font-size: 2rem;
    line-height: 2.5rem;
  }
`;
